import React, { Component } from "react";
import Isotope from "isotope-layout/js/isotope";
import ImagesLoaded from "imagesloaded/imagesloaded";
import projects, { clients } from "./projects";

const GithubIcon = () => (
  <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
    <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82a7.4 7.4 0 0 1 2-.27c.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.01 8.01 0 0 0 16 8c0-4.42-3.58-8-8-8z" />
  </svg>
);

class ItemGrid extends Component {
  state = {
    activeItem: "*",
  };

  componentDidMount() {
    const imgLoad = new ImagesLoaded(".grid");

    imgLoad.on("always", () => {
      this.iso = new Isotope(".grid", {
        itemSelector: ".grid-item",
        layoutMode: "masonry",
      });
    });
  }

  onFilterChange = (newFilter) => {
    this.setState({ activeItem: newFilter });

    if (this.iso === undefined) {
      this.iso = new Isotope(".grid", {
        itemSelector: ".grid-item",
        layoutMode: "masonry",
      });
    }

    this.iso.arrange({ filter: newFilter === "*" ? "*" : `.${newFilter}` });
  };

  onActive = (v) => (v === this.state.activeItem ? "active" : "");

  renderLinks(project) {
    if (project.visibility === "internal") {
      return (
        <span className="pf-locked" title="Internal delivery, not publicly linked">
          <i className="icon-lock"></i>
        </span>
      );
    }

    return (
      <div className="icons">
        {project.live && (
          <a
            href={project.live}
            target="_blank"
            rel="noopener noreferrer"
            title={`Visit ${project.title}`}
          >
            <i className="icon-magnifying-glass"></i>
          </a>
        )}
        {project.repo && (
          <a
            href={project.repo}
            target="_blank"
            rel="noopener noreferrer"
            title={`${project.title} on GitHub`}
          >
            <GithubIcon />
          </a>
        )}
      </div>
    );
  }

  render() {
    return (
      <div>
        <ul className="list_style portfolio_menu text-center">
          {clients.map((client) => (
            <li
              key={client.key}
              className={this.onActive(client.key)}
              data-filter={client.key}
              onClick={() => this.onFilterChange(client.key)}
            >
              {client.label}
            </li>
          ))}
        </ul>

        <div className="grid row">
          {projects.map((project) => (
            <div
              key={project.id}
              className={`col-md-3 col-sm-6 col-xs-12 grid-item ${project.clientKey}`}
            >
              <div className="portfolio hover-style">
                <img src={project.image} alt={project.title} />
                <div className="item-img-overlay">
                  <div className="overlay-info text-center">
                    <h6 className="sm-titl">{project.title}</h6>
                    {this.renderLinks(project)}
                  </div>
                </div>
              </div>
              <div className="pf-caption">
                <h5 className="pf-name">{project.title}</h5>
                <span className="pf-meta">
                  {project.client}
                  <span className={`pf-badge pf-badge-${project.visibility}`}>
                    {project.visibility === "public" ? "Public" : "Private"}
                  </span>
                </span>
                {project.role && <p className="pf-role">{project.role}</p>}
                <p className="pf-summary">{project.summary}</p>
                {project.highlights && (
                  <ul className="pf-highlights list_style">
                    {project.highlights.map((h) => (
                      <li key={h}>{h}</li>
                    ))}
                  </ul>
                )}
                <ul className="pf-tech list_style">
                  {project.tech.map((t) => (
                    <li key={t}>{t}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default ItemGrid;
